import { render, staticRenderFns } from "./typeUser.vue?vue&type=template&id=71e5891e&scoped=true&"
import script from "./typeUser.vue?vue&type=script&lang=js&"
export * from "./typeUser.vue?vue&type=script&lang=js&"
import style0 from "./typeUser.vue?vue&type=style&index=0&id=71e5891e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e5891e",
  null
  
)

export default component.exports